<template>
  <b-card border-variant="dark" class="rounded-custom-1 border-custom-2 p-0 p-md-5">
    <b-row class="justify-content-center">
      <b-col md="10">
        <b-card-title class="sign-up-title text-center">Check your email!</b-card-title>
        <check-email-icon class="pl-0 pl-md-5 ml-0 ml-md-5 mt-2" />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import CheckEmailIcon from '@/assets/images/checkemail.svg'

export default {
  name: 'CheckEmailWorkspace',

  components: {
    CheckEmailIcon
  }
}
</script>
